import React, { useState, useMemo } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { redefinirSenhaComToken } from '../services/passwordReset'
import './Auth.css'

const RedefinirSenhaPublica = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = useMemo(() => searchParams.get('token') || '', [searchParams])

  const [novaSenha, setNovaSenha] = useState('')
  const [confirmarSenha, setConfirmarSenha] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (!token) {
      setError('Link inválido. Solicite uma nova recuperação de senha.')
      return
    }
    if (novaSenha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres.')
      return
    }
    if (novaSenha !== confirmarSenha) {
      setError('As senhas não coincidem.')
      return
    }

    setLoading(true)
    const result = await redefinirSenhaComToken(token, novaSenha)
    setLoading(false)

    if (!result.success) {
      setError(result.error || 'Não foi possível redefinir a senha.')
      return
    }

    setDone(true)
  }

  return (
    <div className="auth-page">
      <div className="auth-glass-card">
        <Link to="/login" className="auth-back-link">
          <svg xmlns="http://www.w3.org/2000/svg" className="auth-back-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Voltar para o login
        </Link>

        <div className="auth-header-block auth-header-block-left">
          <h1 className="auth-page-title">Nova senha</h1>
          <p className="auth-subtitle auth-subtitle-left">
            {done
              ? 'Sua senha foi atualizada. Você já pode entrar no sistema.'
              : 'Defina uma nova senha para sua conta.'}
          </p>
        </div>

        {error && (
          <div className="auth-alert auth-alert-error" role="alert">
            {error}
          </div>
        )}

        {done ? (
          <button type="button" className="auth-btn-primary" onClick={() => navigate('/login')}>
            IR PARA O LOGIN
          </button>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form-modern">
            <div className="auth-field">
              <label htmlFor="nova-senha" className="auth-label">
                Nova senha
              </label>
              <input
                type="password"
                id="nova-senha"
                className="auth-input"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                placeholder="••••••••"
                required
                minLength={6}
                disabled={loading || !token}
                autoComplete="new-password"
              />
            </div>
            <div className="auth-field">
              <label htmlFor="confirmar-senha" className="auth-label">
                Confirmar senha
              </label>
              <input
                type="password"
                id="confirmar-senha"
                className="auth-input"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                placeholder="••••••••"
                required
                minLength={6}
                disabled={loading || !token}
                autoComplete="new-password"
              />
            </div>
            {!token && (
              <p className="auth-hint-warning">
                Link incompleto.{' '}
                <Link to="/esqueci-senha" className="auth-link">
                  Solicitar novo link
                </Link>
              </p>
            )}
            <button type="submit" className="auth-btn-primary" disabled={loading || !token}>
              {loading ? 'SALVANDO...' : 'SALVAR NOVA SENHA'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

export default RedefinirSenhaPublica
